<mat-dialog-content class="cosmos-cluster-details-modal__modal">
  <div class="cosmos-cluster-details-modal__close-button-wrapper">
    <button
      (click)="closeDetails()"
      class="cosmos-cluster-details-modal__close-button-wrapper__button"
    >
      <mat-icon>
        <span>close</span>
      </mat-icon>
    </button>
  </div>
  <cosmos-cluster-summary [cluster]="_cluster"></cosmos-cluster-summary>
  <div
    *ngIf="!!_cluster"
    class="cosmos-cluster-details-modal__column">
      <ng-container *ngIf="!_cluster.isPrivate; then displayPublic else displayPrivate"></ng-container>
      <cosmos-cluster-collaborators></cosmos-cluster-collaborators>
      <cosmos-cluster-invites></cosmos-cluster-invites>
    <button
      *ngIf="_cluster"
      (click)="deleteCluster()"
      class="cosmos-cluster-details-modal__delete-button"
    >
      Delete Cluster
    </button>
  </div>
</mat-dialog-content>

<ng-template #displayPrivate>
  <ng-container *ngIf="_showPublic; else displayPublic">
    <div class="cosmos-cluster-details-modal__private-template">
      <span class="cosmos-cluster-details-modal__private-template__text">
        This section is private. Click button to see elements.
      </span>
      <button
        (click)="showPrivateElements()"
        class="cosmos-cluster-details-modal__private-template__button"
      >
        Show Private
      </button>
    </div>
  </ng-container>
</ng-template>

<ng-template #displayPublic>
  <cosmos-cluster-elements></cosmos-cluster-elements>
</ng-template>
